import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/retour.png'


const _withScopeId = n => (_pushScopeId("data-v-93310108"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("canvas", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-16 h-16 bg-blue-500 rounded-full",
  src: _imports_0,
  alt: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Questions = _resolveComponent("Questions")!
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Questions, {
      id: "card",
      Presentation: "Action et Réaction : Lorsque deux objets interagissent, ils exercent des forces \n    l'un sur l'autre. Ces forces sont toujours égales en magnitude mais opposées en direction. Si un objet A exerce une force sur un objet B, alors B exerce une force de même magnitude sur A, mais dans la direction opposée.\n    Importance de la Loi : Ce principe est crucial pour comprendre le comportement des objets en interaction. Il est à la base de nombreuses technologies, comme le fonctionnement des fusées. Lorsqu'une fusée expulse des gaz \n    vers l'arrière (action), les gaz exercent une force opposée qui propulse la fusée vers l'avant (réaction)",
      titre: "Troisième principe de la dynamique : Action et réaction",
      cacherCard: _ctx.cacherCard,
      questions: _ctx.questions,
      fichier: "action_reaction"
    }, null, 8, ["cacherCard", "questions"]),
    _createElementVNode("main", {
      class: _normalizeClass({ 'blur-sm': _ctx.flou == true })
    }, [
      _createElementVNode("div", {
        class: "absolute top-2 left-2 bg-white py-3 px-4 bg-white rounded-full flex justify-center items-center cursor-pointer",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.testfinal && _ctx.testfinal(...args)))
      }, " Fin de la simulation "),
      _createVNode(_component_LoadingScreen, { isLoaded: _ctx.loaded }, null, 8, ["isLoaded"]),
      _hoisted_1,
      _createVNode(_component_RouterLink, {
        to: "/categorie",
        class: "fixed z-40 right-2 bottom-5 w-16 h-16",
        onClick: _ctx.actualiser
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["onClick"])
    ], 2)
  ], 64))
}